import { BaseDocument } from "./base";
import { Money } from "./money";

export enum ETransactionTypeFreelancers {
    PAYOUT = 'PAYOUT', // Money taken away from wallet to be transferred to a bank account
    TASK_FINALIZATION = 'TASK_FINALIZATION', // Payment upon task completion
    PROJECT_MANAGEMENT = 'PROJECT_MANAGEMENT', // Payment for project management
    PM_ROADMAP_VERIFIED = 'PM_ROADMAP_VERIFIED', // Payment for roadmap verification
    TRANSACTION_FEE = 'TRANSACTION_FEE', // Transaction fees deducted
    BONUS = 'BONUS', // Additional payment or incentive
    DISPUTE = 'DISPUTE', // Money taken away from wallet due to dispute
}

export interface FreelancerTransaction extends BaseDocument {
    walletId: string,
    type: ETransactionTypeFreelancers,
    credits?: number,
    description?: string,
    projectId?: string,
    taskId?: string,
}

export interface FreelancerWallet extends BaseDocument {
    freelancerId: string,
    credits: number,
    totalEarningsCredits: number,
    totalPayoutCredits: number,
    totalPayoutUsd: number,
}